import get from 'lodash/get';

import BIDS from './types';
import {createOffer} from '~/api/offers';
import {prepare} from '~/misc/create';
import saferwatch from '~/api/saferwatch';
import {updateUser} from '~/modules/user/actions';
import {promiseAction, failAction, ActionError} from '~/misc/dispatch';
import {track} from '~/misc/metrics';
import {getLoad} from '~/misc/metrics/utils';
import { cteateBids, createBidDynamic, getBidLoads as ApiGetBidLoads, acceptBid, confirmBid as apiConfirmBid} from '~/api/bid'
export const readSuccessMessage = prepare(BIDS.BIDS_SUCCESS_MESSAGE_READED);

const messages = {
  missingDot: 'Please, fill the DOT field',
  wrongDotFormat: 'Please, use 5-7 digit DOT',
  missingAmount: 'Please, fill the Price field',
  numbersOnly: 'Please, use digits only for the Price field',
  invalidDot: 'Please, use valid carrier DOT number',
};

const checkDOT = (getState, inputDot) => saferwatch(getState, `/DOT/${inputDot}`).catch((error) => {
  if (error.response && error.response.status === 404) {
    throw new ActionError(messages.invalidDot);
  }
  throw error;
}).then((response) => {
  if (get(response, 'operation.types.carrier') !== 'Yes') {
    throw new ActionError(messages.invalidDot);
  }
  return response;
});

const userDataToChange = (userState, inputDot, sw) => {
  const swIdentity = get(sw, '[CarrierService.CarrierLookup].CarrierDetails.Identity');
  const companyName = swIdentity.dbaName || swIdentity.legalName;

  if (!companyName) {
    return {dot: inputDot};
  }

  return {dot: inputDot, company: {name: companyName}};
};

const ensureUserDot = (dispatch, getState, inputDot, userDot) => {
  if (`${inputDot}` === `${userDot}`) {
    return Promise.resolve();
  }

  return checkDOT(getState, inputDot).then((sw) => {
    const id = getState().user.id;
    return dispatch(updateUser(id, userDataToChange(getState().user, inputDot, sw)));
  });
};

export const makeBid = ({ price, shipmentId }) => (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  BIDS.BIDS_MADE,
  cteateBids(getState, price, shipmentId )
)

export const makeBidDynamic = ({ price, shipmentId, nextNode }) => (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  BIDS.BIDS_MADE_DYNAMIC,
  createBidDynamic(getState, shipmentId, nextNode ,price )
)

export const confirmBid = (id) => (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  BIDS.BIDS_CONFIRM,
  apiConfirmBid(getState, id)
)


export const getBidsLoads = () => (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  BIDS.BIDS_GET,
  ApiGetBidLoads(getState),
)

export const accpetBid = (nextNode) => (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  BIDS.BIDS_ACCEPT,
  acceptBid(getState, nextNode),
)

/* export const makeBid = (loadId, loadIdentity, dot, amountText) => (dispatch, getState) => {
  const rebid = get(getState(), ['bids', 'index', loadId, 'value']);
  const amount = parseFloat(amountText);
  track('make_bid_requested', {
    load: getLoad(loadId, getState(), loadIdentity),
    price: amount || null,
    priceOriginal: amountText,
    rebid,
    dot,
  });

  const fail = (message) => failAction(dispatch, BIDS.BIDS_MADE, new ActionError(message), {loadId: loadId});

  if (!dot) {
    return fail(messages.missingDot);
  }

  if (dot.length < 5 || dot.length > 7) {
    return fail(messages.wrongDotFormat);
  }

  if (!amount) {
    return fail(messages.missingAmount);
  }

  if (!(`${amountText}`).match(/^\d+$/)) {
    return fail(messages.numbersOnly);
  }

  const {dot: userDot} = getState().user;

  return promiseAction(
    dispatch,
    getState,
    BIDS.BIDS_MADE,
    ensureUserDot(dispatch, getState, dot, userDot)
      .then(() => createOffer(getState, loadId, amount)
        .then(() => {
          track('make_bid_result', {
            load: getLoad(loadId, getState(), loadIdentity),
            price: amount,
            rebid,
            dot,
            outcome: 'make',
          });
          return ({offer_amount: amount});
        })
      ),
    {loadId: loadId}
  );
}; */



// WEBPACK FOOTER //
// ./src/modules/bids/actions.js